import { gql } from '@apollo/client'

export const COMPANY_RANKING_SETTINGS_FOR_COUNTRY = gql`
  query CompanyRankingSettingsForCountry($companyId: HashedId!, $country: Country!) {
    companyRankingSettingsForCountry(companyId: $companyId, country: $country) {
      topPercentage
      lowPercentage
      lowPercentageIsBlocker
      rankingIsDisabled
      tagAssignmentIsInProgress
    }
  }
`
